import { createContext, useContext } from 'react'

export type ToastTone = 'good' | 'bad'
export const ToastContext = createContext<(text: string, tone?: ToastTone) => void>(() => {})

/** Confirms what just happened, in the past tense: "Posted to Loaf". */
export function useToast() {
  return useContext(ToastContext)
}
